import { EventEmitter } from '@smartgift/frontend-toolkit';

import { configs } from '@hero/configs';
import { CLICKSTREAM_EVENTS, GTM_EVENTS } from '@hero/constants';

import * as clickstream from './click-stream-event';
import * as gtm from './gtm-event';

const events = ['pageView'];

export const trackerManager = new EventEmitter();

const trackers = {
  clickstream: {
    events: Object.keys(CLICKSTREAM_EVENTS),
    enabled: configs.tracker.clickstream.enabled,
    event: clickstream.customEvent
  },
  gtm: {
    events: Object.keys(GTM_EVENTS),
    enabled: configs.tracker.gtm.enabled,
    event: gtm.customEvent
  }
};

for (const event of events) {
  trackerManager.on(event, (data = {}) => {
    for (const tracker in trackers) {
      const activeTracker = trackers[tracker];
      const isValidEvent = activeTracker.events.includes(event);

      if (activeTracker.enabled && isValidEvent) {
        activeTracker.event?.({ eventType: event, ...data });
      }
    }
  });
}
